<template>
    <div class="card conteiner">
        <search id="searchComponent" class="mb-4"></search>
        <div v-if="(this.url == 'puja.index' || this.url == 'puja.detalle')" class="modal fade bd-example-modal-xl"
            id="viewQuestions" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header bg bg-primary text-white">
                        <h5 class="modal-title" id="exampleModalLabel">Preguntas: {{ this.titulo }}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-2" v-for="(question, index) in questions" v-bind:value="question.id"
                            :key="index">
                            <div class="col-12"><i class="fas fa-question-circle text-primary"></i> {{ question.question
                                }}
                            </div>
                            <div class="col-12 text-muted text-justify">
                                <i v-if="question.answer != 'Sin respuesta del vendedor'"
                                    class="fas fa-comment-alt text-primary pl-3"></i>
                                <i v-else class="fas fa-minus-square text-primary pl-3"></i>
                                <span v-if="question.answer_yn == 1">Sí: {{ question.answer }}</span>
                                <span v-else-if="question.answer_yn == 2">No: {{ question.answer }}</span>
                                <span v-else>{{ question.answer }}</span>
                                <small class="text-italic">{{ question.reply_date }}</small>
                            </div>
                        </div>
                        <div class="col-12" v-if="questions.length == 0">
                            <i class="fas fa-exclamation-triangle text-primary pr-1"></i>
                            No hay preguntas relacionadas con este producto.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="(this.url == 'puja.index' || this.url == 'puja.detalle')" class="modal fade bd-example-modal-xl"
            id="setQuestion" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header bg bg-primary text-white">
                        <h5 class="modal-title" id="exampleModalLabel">Hacer pregunta: {{ this.titulo }}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12 alert alert-primary text-justify" role="alert">
                            <i class="fas fa-exclamation-triangle pr-1"></i>
                            <b>Nota:</b> Cuando realizas una pregunta, ésta se hará para todos los vendedores que estén
                            participando en la oferta
                        </div>
                        <div class="form-group row">
                            <label for="ALNUM_question" class="col-12 col-form-label">Cometario</label>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="input-group col-11">
                                        <textarea ref="text_question" rows="6" class="form-control cuenta_caracteres"
                                            id="ALNUM_question" type="text" placeholder="Ingresa la pregunta"
                                            onkeyup="validar(this.form);cuenta_caracteres(this)" name="question"
                                            autocomplete="details" v-model="question" maxlength="256">
                                    </textarea>
                                    </div>
                                    <span id="span_ALNUM_question" class="my-auto" aria-hidden="true"></span>
                                </div>
                                <div class="row justify-content-between">
                                    <div class="col-11">
                                        <div class="row no-gutters justify-content-between">
                                            <div class="col-auto">
                                                <div id="div_ALNUM_question" class="form-text text-danger"></div>
                                            </div>
                                            <div class="col-auto text-muted my-auto">Caracteres restantes: <i
                                                    class="num_cuenta_carac">256</i></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-12 pt-2">
                                <button type="button" class="btn btn-primary" @click="saveQuestion()"
                                    data-dismiss="modal">
                                    <i class="fas fa-save"></i>
                                    Guardar pregunta
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.url == 'puja.detalle' || this.url == 'puja.index'" class="modal fade bd-example-modal-xl"
            id="setSale" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header bg bg-primary text-white">
                        <h5 class="modal-title" id="exampleModalLabel">Comenzar proceso de compra</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12 alert alert-primary text-justify" role="alert">
                            <i class="fas fa-exclamation-triangle pr-1"></i>
                            <b>Nota:</b> Una vez que inicies el proceso de compra, se notificará al vendedor para que
                            coordinen la entraga del producto y se calcule el precio final a pagar, considerando el
                            costo
                            por envío o traslado del producto (si es que corresponde)
                        </div>

                        <div class="card-body h5">
                            <div class="alert-success row p-2">
                                <div class="col-12 row "><label
                                        class="col-12 col-lg-3 text-lg-right font-weight-bold">Producto:</label>
                                    <div class="col-12 col-lg-9">{{ this.titulo_post }}</div>
                                </div>
                                <div class="col-12 row pt-2"><label
                                        class="col-12 col-lg-3 text-lg-right font-weight-bold">Estado:</label>
                                    <div class="col-12 col-lg-9">{{ this.estado_post }}</div>
                                </div>
                                <div class="col-12 row pt-2"><label
                                        class="col-12 col-lg-3 text-lg-right font-weight-bold">Precio final:</label>
                                    <div class="col-12 col-lg-9">{{ this.precio_post.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
        }) }}</div>
                                </div>
                                <div class="col-12 row pt-2"><label
                                        class="col-12 col-lg-3 text-lg-right font-weight-bold">Cantidad:</label>
                                    <div class="col-12 col-lg-9">{{ this.cantidad }}</div>
                                </div>
                                <div class="col-12 row pt-2"><label
                                        class="col-12 col-lg-3 text-lg-right font-weight-bold">Vendedor:</label>
                                    <div class="col-12 col-lg-9">{{ this.vendedor_post }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 pt-2">
                            <button type="button" class="btn btn-success" @click="saveSale()" data-dismiss="modal">
                                <i class="fas fa-check pr-1"></i>
                                Comprar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.url == 'pujapost.index'" class="modal fade bd-example-modal-xl" id="setPrice" tabindex="-1"
            role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header bg bg-primary text-white">
                        <h5 class="modal-title" id="exampleModalLabel">Bajar precio: {{ this.titulo }}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12 alert alert-primary text-justify" role="alert">
                            <p><i class="fas fa-exclamation-triangle pr-1"></i>
                                <b>Nota:</b> Cuando se ha alcanzado el precio mínimo de venta, se habilita la opción
                                para
                                poder bajar el precio de forma manual
                            </p>
                            <p>Te sugerimos actualizar a un precio menor al del primer producto del Ranking <b>({{
            this.total_minprice_print }})</b>, para que tengas más opciones de tener el mejor
                                precio
                                de
                                puja</p>
                        </div>

                        <div class="form-group row">
                            <label for="ONUME_maxprice" class="col-md-3 col-form-label text-md-right">Precio
                                Actual<sup>&nbsp;(*)&nbsp;</sup></label>
                            <div class="col-md-9">
                                <div class="row">
                                    <div class="input-group col-11">
                                        <input ref="precioActual" id="ONUME_maxprice" readonly v-model="precio_inicial"
                                            name="maxprice" @keyup="enmascararValor" class="form-control" />
                                    </div>
                                    <span id="span_ONUME_maxprice" class="my-auto" aria-hidden="true"></span>
                                </div>
                                <div id="div_ONUME_maxprice" class="form-text text-danger"></div>
                                <div class="form-text text-danger"></div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="ONUME_minprice" class="col-md-3 col-form-label text-md-right">Precio
                                rebajado<sup>&nbsp;(*)&nbsp;</sup></label>
                            <div class="col-md-9">
                                <div class="row">
                                    <div class="input-group col-11">
                                        <input ref="precioRebajado" id="ONUME_minprice" name="minprice"
                                            @keyup="enmascararValor" class="form-control" data-toggle="tooltip"
                                            data-placement="top" v-model="newPrice"
                                            title="El precio menor corresponde al último precio al que puede llegar el producto, al hacer la oferta automática. Este deber ser menor al precio inicial." />
                                    </div>
                                    <span id="span_ONUME_minprice" class="my-auto" aria-hidden="true"></span>
                                </div>
                                <div id="div_ONUME_minprice" class="form-text text-danger"></div>
                                <div class="form-text text-danger"></div>
                            </div>
                        </div>

                        <div class="col-12 pt-2">
                            <button name="boton_precio" id="boton_precio" type="button" class="btn btn-primary"
                                @click="savePrice()" data-dismiss="modal">
                                <i class="fas fa-save"></i>
                                Guardar precio
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body h6">
            <div class="alert alert-success rounded row">
                <div class="col-12 row mt-2">
                    <label class="col-12 col-lg-3 text-lg-right font-weight-bold">Categoría:</label>
                    <div class="col-12 col-lg-9">{{ this.category_path }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Título:</label>
                    <div class="col-12 col-lg-9">{{ this.puja_title }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Duración:</label>
                    <div class="col-12 col-lg-9">{{ this.puja_time }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Cantidad:</label>
                    <div class="col-12 col-lg-9">{{ this.puja_total }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Fecha
                        Inicio:</label>
                    <div class="col-12 col-lg-9">{{ this.puja_start }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Fecha
                        Final:</label>
                    <div class="col-12 col-lg-9">{{ this.puja_end }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Estado:</label>
                    <div class="col-12 col-lg-9">{{ this.puja_state }}</div>
                </div>
                <div class="col-12 row"><label class="col-12 col-lg-3 text-lg-right font-weight-bold">Calificación
                        Comprador:</label>
                    <div class="col-12 col-lg-9">
                        <div class="d-flex flex-row">
                            <div class="ratings-good-nbg">
                                <i v-for="i in this.avg_comprador" :key="i" class="fas fa-star"></i>
                            </div>
                            <div class="ratings-empty mr-2">
                                <i v-for="i in 5 - this.avg_comprador" :key="i" class="fas fa-star"></i>
                            </div>
                            <span>{{ this.avg_comprador }} / 5 | {{ this.compras_reales }} compras</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <countdown v-if="this.puja_state == 'Activa'" :endDate="date_end"></countdown>

        <div class="row p-2">
            <div class="col-lg-6 h4 mt-3 mb-1 font-weight-bold">Ranking Productos ({{ this.posts.length }})</div>
            <div class="col-lg-6 mt-3 text-right">
                <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-end">
                    <button v-if="this.url == 'puja.index' || this.url == 'pujapost.index'" type="button"
                        @click="$router.back()" class="btn btn-primary mb-1 col-12 col-lg-auto mr-1">
                        <i class="fas fa-arrow-left"></i>
                        Volver
                    </button>
                    <button v-if="this.url == 'puja.detalle'" type="button" @click="this.$router.push('/pujas')"
                        class="btn btn-primary mb-1 col-12 col-lg-auto mr-1">
                        <i class="fas fa-arrow-left"></i>
                        Volver
                    </button>
                    <button
                        v-if="(this.url == 'puja.index' || this.url == 'puja.detalle' || this.url == 'pujapost.index') && this.puja_state == 'Activa'"
                        type="button" class="btn btn-primary mb-1 col-12 col-lg-auto mr-1" @click="loadPost">
                        <i class="fas fa-sync"></i>
                        Actualizar
                    </button>
                    <button
                        v-if="(this.url == 'puja.index' || this.url == 'puja.detalle') && this.puja_state == 'Activa'"
                        type="button" class="btn btn-success mb-1 col-12 col-lg-auto mr-1" key="" data-toggle="modal"
                        data-target="#setQuestion" @click="limpiarPregunta">
                        <i class="fas fa-plus pr-1"></i>
                        Preguntar
                    </button>
                </div>
            </div>
        </div>


        <div class="table-responsive">
            <table id="tabla_contenedora" class="table table-striped table-hover table-bordered">
                <caption>Listado de publicaciones para la oferta</caption>
                <thead>
                    <tr>
                        <th scope="col">Título</th>
                        <th scope="col">Portada</th>
                        <th scope="col">Precio Inicial</th>
                        <th scope="col">Precio Actual</th>
                        <th v-if="this.url == 'puja.index' || this.url == 'Detalle' || this.url == 'puja.detalle'"
                            scope="col">Ranking Vendedor</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Costo de Envío</th>
                        <th scope="col" class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody v-if="this.url == 'puja.index' || this.url == 'Detalle' || this.url == 'puja.detalle'">
                    <tr v-for="(post, index) in posts" v-bind:value="post.id" :key="index"
                        v-bind:class="post.class_tr_compra">
                        <td class="text-nowrap">
                            <!-- router-link :to="{ name: 'detail', params: { id: post.id }}" -->
                            <a :href="$router.resolve({ name: 'detail', params: { slug: post.slug } }).href">
                                {{ post.titulo_prod }}
                            </a>
                            <!-- /router-link -->
                        </td>
                        <td>
                            <div class="col-1">
                                <img id="first-image" :src="'/post_images/' + post.id + '/' + post.image"
                                    style="max-width:80px;max-height: 80px;" />
                            </div>
                        </td>
                        <td>
                            {{ post.precio_inicio.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
        }) }}
                        </td>
                        <td>
                            {{ post.precio_actual.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
        }) }}
                        </td>
                        <td class="text-nowrap">
                            {{ post.user_name }}
                            <div class="d-flex flex-row">
                                <div class="ratings-good-nbg">
                                    <i v-for="i in post.avg" :key="i" class="fas fa-star"></i>
                                </div>
                                <div class="ratings-empty mr-2">
                                    <i v-for="i in 5 - post.avg" :key="i" class="fas fa-star"></i>
                                </div>
                                <span>{{ post.avg }} / 5 | {{ post.ventas_reales }} ventas</span>
                            </div>
                        </td>
                        <td>{{ post.estado_prod }}</td>
                        <td class="">
                            A convenir<br> con el vendedor
                        </td>
                        <td class="text-center text-nowrap">
                            <span class=" text-danger" v-if="post.answer_yn == 2"><i class="fas fa-times pr-1"></i>
                                Responde
                                No </span>
                            <span class=" text-success" v-if="post.answer_yn == 1"><i class="fas fa-check pr-1"></i>
                                Responde
                                Sí</span>
                            <button type="button" class="btn btn-outline-primary btn-block" key="" data-toggle="modal"
                                data-target="#viewQuestions" :data-id="post.id"
                                @click="loadQuestion(post.id, post.title)">
                                <i class="fas fa-eye pr-1"></i>
                                Preguntas
                            </button>
                            <button v-if="post.estado == 'Finalizada' && post.postpujaestado_id == 1 && post.stock > 0"
                                type="button" class="btn btn-outline-success btn-block" key="x" data-toggle="modal"
                                data-target="#setSale" :data-id="post.postpuja_id"
                                @click="setSale(post.titulo_prod, post.estado_prod, post.precio_actual, post.user_name, post.postpuja_id)">
                                <i class="fas fa-shopping-bag"></i>
                                Comprar
                            </button>
                            <button v-if="post.estado != 'Activa' && post.stock == 0" type="button"
                                class="btn btn-outline-danger btn-block" key="xx" disabled :data-id="post.postpuja_id">
                                <i class="fas fa-ban"></i>
                                Vendido
                            </button>
                            <button v-if="post.estado != 'Activa' && post.postpujaestado_id == 3" type="button"
                                class="btn btn-outline-success btn-block" key="xx" disabled :data-id="post.postpuja_id">
                                <i class="fas fa-check"></i>
                                Comprada
                            </button>

                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-bind:ref="post.user_id" v-for="(post, index) in posts" v-bind:value="post.user_id"
                        :key="index" v-bind:class="post.class_tr_vende">
                        <td class="text-nowrap">
                            {{ post.titulo_prod }}
                        </td>
                        <td>
                            <div class="col-1">
                                <img id="first-image" :src="'/post_images/' + post.id + '/' + post.image"
                                    style="max-width:80px;max-height: 80px;" />
                            </div>
                        </td>
                        <td>
                            {{ post.precio_inicio.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
        }) }}
                        </td>
                        <td>
                            {{ post.precio_actual.toLocaleString("es-CL", {
            style: "currency",
                            currency: "CLP",
                            }) }}
                        </td>
                        <!-- td class="text-nowrap">
                        {{post.user_name}}
                        <br>valoración
                        <br>número de ventas
                    </td -->
                        <td>{{ post.estado_prod }}</td>
                        <td class="">
                            A convenir<br> con el vendedor
                        </td>
                        <td class="text-center text-nowrap">
                            <!--a href="" class="btn btn-outline-primary btn-block">
                            <i class="fas fa-eye pr-1"></i>
                            Ver Detalle
                        </a -->
                            <button type="button" v-bind:class="post.class_button" key="" data-toggle="modal"
                                data-target="#setPrice" :data-id="post.id"
                                @click="loadPrice(post.id, post.titulo_prod, post.precio_actual)"
                                :disabled="post.disabled_button">
                                <i class="fas fa-edit"></i>
                                Cambiar Precio
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style>
.modal-dialog {
    height: 100vh;
    width: 95vw;
    display: flex;
    align-items: center;
}
</style>
<script>
export default {
    props: ['url', 'user_id'],
    data: function () {
        return {
            postSelected: "",
            posts: [],
            questions: [],
            total: 0,
            currentPage: 1,
            titulo: '',
            question: '',
            precio_actual: '',
            precio_inicial: '',
            newPrice: '',
            titulo_post: '',
            estado_post: '',
            precio_post: '',
            vendedor_post: '',
            postpuja_selected: '',
            cantidad: 0,
            total_minprice: 0,
            total_minprice_print: 0,
            category_path: '',
            puja_title: '',
            puja_time: '',
            puja_total: 0,
            puja_start: '',
            puja_end: '',
            puja_state: '',
            avg_comprador: 0,
            compras_reales: 0,
            date_end: new Date(),
        };
    },
    created() {

    },
    mounted() {
        //this.posts[0].category_path = '';
        //this.$router.go();
        this.loadPost();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    },
    updated() {
        if (this.url != 'puja.index') {
            if (this.precio_inicial) {
                obtener_precio(this.$refs.precioActual);
            }
            var maxprice = this.$refs.precioActual;
            validar(document.formulario);
        }
    },
    watch: {
        // whenever question changes, this function will run
        postSelected(newPost) {
            //console.log('aca'+newPost)
        }
    },
    methods: {
        calcularFechaPosterior() {
            const fechaString = this.puja_end;
            const [day, month, year, time] = fechaString.split(/[- :]/);
            const fecha = new Date(year, month - 1, day, ...time.split(':'));
            this.date_end = fecha;
        },
        loadPost() {
            let timerInterval
            Swal.fire({
                title: 'Preparando el detalle de la oferta',
                timer: 1000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    if (b) {
                        timerInterval = setInterval(() => {
                            b.textContent = Swal.getTimerLeft()
                        }, 100)
                    }
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    console.log('carga completa...')
                }
            });

            axios.get('/api/puja/' + this.$route.params.id).then((response) => {
                this.posts = response.data;
                this.category_path = this.posts[0].category_path;
                this.puja_title = this.posts[0].title;
                this.puja_time = this.posts[0].tiempo;
                this.puja_total = this.posts[0].cantidad;
                this.puja_start = this.posts[0].date_ini;
                this.puja_end = this.posts[0].date_fin;
                this.puja_state = this.posts[0].estado;
                this.avg_comprador = this.posts[0].avg_c;
                this.compras_reales = this.posts[0].compras_reales;
                let precio_menor = parseInt(this.posts[0].precio_actual) - 1;
                this.total_minprice_print = this.posts[0].precio_actual.toLocaleString("es-CL", {
                    style: "currency",
                    currency: "CLP",
                });
                this.total_minprice = precio_menor.toLocaleString("es-CL", {
                    style: "currency",
                    currency: "CLP",
                });
                this.calcularFechaPosterior();
            });
        },
        loadQuestion(id, title) {
            axios.get('/api/questions/' + id).then((response) => {
                this.questions = response.data;
                this.titulo = title;
            });
        },
        loadPrice(id, title, price) {
            this.postSelected = id;
            this.titulo = title;
            this.precio_actual = price
            this.precio_inicial = price;
            this.newPrice = this.total_minprice;
        },
        saveQuestion() {
            axios.post('/api/questions/store', { //estas variables son las que enviaremos para que crear la tarea
                'array': JSON.stringify(this.posts),
                'question': this.question,
                'id_puja': this.$route.params.id
            }
            ).then((response) => {
                //console.log(response);
                if (response.data.msj == 'pregunta_creada') {

                    this.id_puja = response.data.data;
                    //console.log(this.id_puja);
                    this.$swal.fire({
                        text: 'la pregunta será enviada a el/los vendedor(es) que participan en la oferta',
                        title: 'Se ha ingresado la pregunta correctamente',
                        icon: 'success',
                        confirmButtonColor: '#3490dc',
                        confirmButtonText: 'Aceptar',
                    });

                }
            })
                .catch((response) => {
                    this.$swal.fire({
                        text: 'Por favor, trata de ingresarla nuevamente',
                        title: 'No se ha podido ingresar la pregunta',
                        icon: 'error',
                        confirmButtonColor: '#3490dc',
                        confirmButtonText: 'Aceptar',
                    });
                });
        },
        savePrice() {
            if (limpia_precio(this.newPrice) > 0) {
                axios.post('/api/price/store', { //estas variables son las que enviaremos para que crear la tarea
                    'post_id': this.postSelected,
                    'price': this.newPrice,
                    'puja_id': this.$route.params.id
                }).then((response) => {

                    if (response.data.msj == 'precio_actualizado') {
                        this.newPrice = '';
                        this.loadPost();
                        this.$swal.fire({
                            text: 'este será el nuevo precio que verá el comprador en la oferta',
                            title: 'Se ha actualizado el precio correctamente',
                            icon: 'success',
                            confirmButtonColor: '#3490dc',
                            confirmButtonText: 'Aceptar',
                        });

                    }
                })
                    .catch((response) => {
                        this.$swal.fire({
                            text: 'Por favor, trata de ingresarlo nuevamente',
                            title: 'No se ha podido actualizar el precio',
                            icon: 'error',
                            confirmButtonColor: '#3490dc',
                            confirmButtonText: 'Aceptar',
                        });
                    });
            }
            else {
                this.$swal.fire({
                    text: 'Por favor, trata de actualizar el precio a un valor válido',
                    title: 'No se puede establecer el precio de venta sin valor',
                    icon: 'error',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar'
                });
            }
        },
        saveSale() {
            //console.log(this.postpuja_selected);
            axios.post('/api/sale/store', { //estas variables son las que enviaremos para que crear la tarea
                'postpuja_id': this.postpuja_selected,
                'precio': this.precio_post,
                'cantidad': this.cantidad
            }).then((response) => {
                //console.log(response);
                if (response.data.msj == 'compra_creada') {
                    this.loadPost();
                    this.$swal.fire({
                        text: 'se ha enviado una notificación al vendedor, para coordinar la venta',
                        title: 'Se ha iniciado la compra correctamente',
                        icon: 'success',
                        confirmButtonColor: '#3490dc',
                        confirmButtonText: 'Aceptar',
                    });
                }
                else if (response.data.msj == 'compra_sin_stock') {
                    this.$swal.fire({
                        text: 'Al momento de hacer la compra, el producto ya fue vendido, por lo que ya no tiene stock disponible',
                        title: 'No se ha podido realizar la compra',
                        icon: 'error',
                        confirmButtonColor: '#3490dc',
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
                .catch((response) => {
                    this.$swal.fire({
                        text: 'Por favor, trata de ingresarla nuevamente',
                        title: 'No se ha podido iniciar la compra',
                        icon: 'error',
                        confirmButtonColor: '#3490dc',
                        confirmButtonText: 'Aceptar',
                    });
                });
        },
        setSale(titulo, estado, precio, vendedor, id_postpuja) {
            this.titulo_post = titulo;
            this.estado_post = estado;
            this.precio_post = precio;
            this.postpuja_selected = id_postpuja;
            this.vendedor_post = vendedor;
            this.cantidad = this.posts[0].cantidad;
            //console.log('puja_selected'+id_postpuja);
        },
        enmascararValor() {
            var minprice = this.$refs.precioRebajado;
            var maxprice = this.$refs.precioActual;
            var v_minprice = limpia_precio(minprice.value);
            var v_maxprice = limpia_precio(maxprice.value);

            obtener_precio(maxprice);

            if (parseInt(v_minprice) >= parseInt(v_maxprice)) {
                this.$swal.fire({
                    text: 'Por favor, ingresar nuevamente',
                    title: 'El precio rebajado debe ser menor al precio actual',
                    icon: 'error',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar',
                });
                minprice.value = '';
            }
            obtener_precio(minprice);

            validar(document.formulario);
        },
        limpiarPregunta() {
            this.$refs.text_question.value = '';
            cuenta_caracteres(this.$refs.text_question);
        }
    }
};
</script>